import blogFetch from "../axios/config.js";
import { getCookie } from "../section/cookie.js";

const getPermissions = async () => {
  let userId = getCookie("userId")
  try {
    const responsePermissions = await blogFetch.get("/User/permissions/" + userId);
    var permissions = responsePermissions.data.map(
      (permission) => permission.permissions_Description
    );

    var concatenatedPermissions = permissions.join(", ");
    return concatenatedPermissions;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export default getPermissions;
